export const IDS = {
  header: {
    logo: 'header-logo',
    navHome: 'nav-home',
    navCatalog: 'nav-catalog',
    navAbout: 'nav-about',
    navContact: 'nav-contact',
    navDashboard: 'nav-dashboard',
    navAdmin: 'nav-admin',
    navCart: 'nav-cart',
    navLogin: 'nav-login',
    navApply: 'nav-apply',
    navLogout: 'nav-logout',
  },
  home: {
    hero: 'home-hero',
    ctaApply: 'home-cta-apply',
    ctaBrowse: 'home-cta-browse',
    categoryGrid: 'home-category-grid',
  },
  apply: {
    form: 'apply-form',
    email: 'apply-email',
    password: 'apply-password',
    contactName: 'apply-contact-name',
    businessName: 'apply-business-name',
    businessType: 'apply-business-type',
    licenseNumber: 'apply-license-number',
    phone: 'apply-phone',
    shippingAddress: 'apply-shipping-address',
    monthlyVolume: 'apply-monthly-volume',
    submit: 'apply-submit',
    successMessage: 'apply-success',
  },
  login: {
    form: 'login-form',
    email: 'login-email',
    password: 'login-password',
    submit: 'login-submit',
    errorMessage: 'login-error',
  },
  catalog: {
    root: 'catalog-root',
    search: 'catalog-search',
    brandFilter: 'catalog-brand-filter',
    categoryFilter: 'catalog-category-filter',
    inStockToggle: 'catalog-instock-toggle',
    clearFilters: 'catalog-clear-filters',
    grid: 'catalog-grid',
    productCard: (id) => `catalog-product-${id}`,
    emptyState: 'catalog-empty',
    pricingLockedNotice: 'catalog-pricing-locked-notice',
  },
  product: {
    root: 'product-detail',
    gallery: 'product-gallery',
    title: 'product-title',
    brand: 'product-brand',
    sku: 'product-sku',
    qtyInput: 'product-qty-input',
    qtyIncrement: 'product-qty-inc',
    qtyDecrement: 'product-qty-dec',
    priceDisplay: 'product-price',
    priceBreaksTable: 'product-price-breaks',
    addToCart: 'product-add-to-cart',
    specsTable: 'product-specs',
    featuresList: 'product-features',
    tabs: 'product-detail-tabs',
    tabDescription: 'tab-description',
    tabSpecifications: 'tab-specifications',
    tabAdditionalInfo: 'tab-additional-info',
    tabDocuments: 'tab-documents',
  },
  cart: {
    root: 'cart-root',
    row: (id) => `cart-row-${id}`,
    qtyInput: (id) => `cart-qty-${id}`,
    remove: (id) => `cart-remove-${id}`,
    subtotal: 'cart-subtotal',
    submitQuote: 'cart-submit-quote',
    notes: 'cart-notes',
    shippingAddress: 'cart-shipping',
    poNumber: 'cart-po',
    empty: 'cart-empty',
    successState: 'cart-success',
  },
  dashboard: {
    root: 'buyer-dashboard',
    quoteRow: (id) => `dashboard-quote-${id}`,
    accountBlock: 'dashboard-account',
  },
  admin: {
    root: 'admin-root',
    tabApplications: 'admin-tab-applications',
    tabAccounts: 'admin-tab-accounts',
    tabQuotes: 'admin-tab-quotes',
    tabProducts: 'admin-tab-products',
    tabLoginLogs: 'admin-tab-login-logs',
    approveUser: (id) => `admin-approve-${id}`,
    rejectUser: (id) => `admin-reject-${id}`,
    discountInput: (id) => `admin-discount-${id}`,
    saveDiscount: (id) => `admin-save-discount-${id}`,
    quoteRow: (id) => `admin-quote-row-${id}`,
    statusSelect: (id) => `admin-quote-status-${id}`,
    productDelete: (id) => `admin-product-delete-${id}`,
    csvUpload: 'admin-csv-upload',
    csvTemplate: 'admin-csv-template',
  },
};
